var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component, Prop } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import _ from 'lodash';
import { UrlHelper } from '../../../helper/UrlWrapper';
import GlobalVue from "../../../globalVue";
import ThirdPartySystemService from '../../../api/ThirdPartySystemService';
import BindGoods from './BindGoods.vue';
import ArtMsglist from "../../../components/alert/ArtMsglist.vue";
var SupplierGoods = (function (_super) {
    __extends(SupplierGoods, _super);
    function SupplierGoods() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.tableHeight = 0;
        _this.total = 0;
        _this.searchParams = {
            name_type: 1,
            key_name: '',
            bind_status: 0
        };
        _this.data = [];
        _this.dialogTableVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.searchTypes = [
            { name: '第三方货品名', value: 1 },
            { name: '绑定货品', value: 2 }
        ];
        _this.statusList = [
            { name: '全部', value: 0 },
            { name: '已绑定', value: 1 },
            { name: '未绑定', value: 2 }
        ];
        _this.placeholder = ['请输入第三方货品名称/编码', '请输入绑定货品搜索'];
        return _this;
    }
    SupplierGoods.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 369;
        }, 300);
        this.service = ThirdPartySystemService.getInstance();
        this.getSupplyGoods();
    };
    SupplierGoods.prototype.getSupplyGoods = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        Object.assign(this.searchParams, { agent_warehouse_id: this.warehouseId }, pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getSupplyGoods(this.searchParams).then(function (res) {
            if (res.data.success) {
                _this.listData = res.data.data;
                _this.total = res.data.total;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    SupplierGoods.prototype.pageChange = function (pager) {
        this.getSupplyGoods(pager);
    };
    SupplierGoods.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    SupplierGoods.prototype.search = function () {
        this.getSupplyGoods();
    };
    SupplierGoods.prototype.bindGoods = function () {
        if (this.selectRows && this.selectRows.length > 1) {
            this.$message.error('选择的货品不能多于1条！');
            return;
        }
        var good_code;
        if (this.selectRows && this.selectRows.length) {
            good_code = this.selectRows[0].goods_code;
        }
        GlobalVue.$emit("addTab", {
            component: BindGoods,
            title: '绑定货品',
            showExist: true,
            name: 'bindGoods_' + this.warehouseId,
            cprops: {
                clientIds: this.warehouseId + '',
                good_code: good_code
            }
        });
    };
    SupplierGoods.prototype.unbindGoods = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error("请选择货品！");
            return;
        }
        var ids = _.reduce(this.selectRows, function (ori, newItem) {
            return ori += ori ? (',' + newItem.goods_id) : newItem.goods_id;
        }, '');
        this.$confirm('确定要解绑选中的货品？', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                _this.service.unbindGoods({ goods_ids: ids }).then(function (res) {
                    if (res.data.success) {
                        if (res.data.code == 40) {
                            var instance = _this.$dialog(ArtMsglist, {
                                data: {
                                    msgData: res.data.data
                                }
                            }, {
                                title: "提示",
                                width: 450,
                                height: 350,
                                closeBtn: false,
                            }).instance;
                            instance.$on("artMsglist:ok", function (data) {
                                var confirm = res.data.data[0].confirm;
                                _this.service.unbindGoods({
                                    goods_ids: ids,
                                    confirm: confirm
                                }).then(function (res) {
                                    if (res.data.success) {
                                        _this.$message.success('解绑成功！');
                                        _this.getSupplyGoods(_this.$refs.pagination.pager);
                                    }
                                });
                            });
                        }
                        else {
                            _this.$message.success('解绑成功！');
                            _this.getSupplyGoods(_this.$refs.pagination.pager);
                        }
                    }
                    window._czc.push(["_trackEvent", '供货货品', '解绑货品', '确定']);
                }, function (err) {
                    _this.$message.error(err.msg || err.message);
                });
            }
        }).catch(function () {
            window._czc.push(["_trackEvent", '供货货品', '解绑货品', '取消']);
        });
    };
    SupplierGoods.prototype.exportFile = function () {
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error("请选择货品！");
            return;
        }
        var exportUrl = "/supplierclientapi/agent_warehouse_goods/export_goods_list";
        exportUrl = UrlHelper.addParam(exportUrl, 'agent_warehouse_id', this.warehouseId);
        exportUrl = UrlHelper.addParam(exportUrl, 'goods_ids', this.selectRows.map(function (item) { return item.goods_id; }).join(","));
        exportUrl = UrlHelper.addParam(exportUrl, "token", this.user.token);
        window.open(exportUrl);
    };
    SupplierGoods.prototype.download = function () {
        window._czc.push(["_trackEvent", '供货货品', '批量解绑', '下载模板']);
    };
    SupplierGoods.prototype.importFile = function () {
        this.dialogTableVisible = true;
        this.setUploadType("beford");
    };
    SupplierGoods.prototype.befordUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (fileType == "xlsx" || fileType == "xls") {
            if (!this.loadingInstance)
                this.loadingInstance = Loading.service({ fullscreen: true });
            return;
        }
        this.$message.error("文件只能是xlsx或xls");
        return false;
    };
    SupplierGoods.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            this.responseSuccess = true;
            var data = response.data;
            this.importSuccessNum = data.success_awg_num;
            this.importFailnum = data.error_num;
            var url = "/supplierclientapi/agent_warehouse_goods/export_error?import_id=" + data.import_id;
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
            this.data = (data.goods_list || []).concat(this.data);
            this.getSupplyGoods();
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || "网络异常，请重新导入";
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    SupplierGoods.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || "网络异常，请重新导入";
        this.uploadEnd();
    };
    SupplierGoods.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = "";
            this.setUploadType("beford");
        }
        else {
            this.setUploadType("after");
        }
        this.loadingInstance.close();
    };
    SupplierGoods.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType("importing");
    };
    SupplierGoods.prototype.setUploadType = function (type) {
        this.befordImport = type == 'beford';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    __decorate([
        Prop({
            default: ''
        })
    ], SupplierGoods.prototype, "warehouseId", void 0);
    SupplierGoods = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], SupplierGoods);
    return SupplierGoods;
}(Vue));
export default SupplierGoods;
